import { render } from "./SCORMViewer.vue?vue&type=template&id=ca320e40&scoped=true&ts=true"
import script from "./SCORMViewer.vue?vue&type=script&lang=ts"
export * from "./SCORMViewer.vue?vue&type=script&lang=ts"

import "./SCORMViewer.vue?vue&type=style&index=0&id=ca320e40&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca320e40"]])

export default __exports__